import { Injectable } from '@angular/core';
import {
  ClaimVerifiedCustomerInformationDto
} from "../../../auto-generated-server-dtos/customer-information/map/claim-verified-customer-information-dto";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class SaveCustomerInformationService {

  constructor(private httpClient: HttpClient) { }

  saveCustomerInformation(claimVerifiedCustomerInformationDto: ClaimVerifiedCustomerInformationDto) {
    return this.httpClient.post(`${environment.apiServer}/SaveCustomerInformation`, claimVerifiedCustomerInformationDto);
  }
}
